import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { BaseResponse } from "../../typings/interfaces";
import { BaseResponseSingle, IRedoReasonResponse } from "../../typings/interfaces/responses";
import {
    GET_ALL_REDO_REASONS,
    ADD_REDO_REASON,
    DELETE_REDO_REASON,
    UPDATE_REDO_REASON,
} from "../../configs/apiConfig";

export const getAllRedoReasonsAction = createAsyncThunk(
    "redo-reasons/all",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<BaseResponse<IRedoReasonResponse>>(
                GET_ALL_REDO_REASONS
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const createRedoReasonAction = createAsyncThunk(
    "redo-reasons/create",
    async (
        {
            storeId,
            merchantId,
            reason,
        }: { storeId: number; merchantId: number; reason: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await axios.post<BaseResponseSingle<IRedoReasonResponse>>(
                ADD_REDO_REASON(merchantId, storeId),
                {
                    merchantId,
                    storeId,
                    reason,
                }
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteRedoReasonAction = createAsyncThunk<
    boolean,
    { merchantId: number; storeId: number; redoReasonId: number }
>(
    "redo-reasons/delete",
    async ({ merchantId, storeId, redoReasonId }, { rejectWithValue }) => {
        try {
            await axios.delete(DELETE_REDO_REASON(merchantId, storeId, redoReasonId));
            return true;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateRedoReasonAction = createAsyncThunk<
    IRedoReasonResponse,
    {
        merchantId: number;
        storeId: number;
        id: number;
        reason: string;
    }
>(
    "redo-reasons/update",
    async ({ merchantId, storeId, id, reason }, { rejectWithValue }) => {
        try {
            const response = await axios.put<BaseResponseSingle<IRedoReasonResponse>>(
                UPDATE_REDO_REASON(merchantId, storeId),
                {
                    id,
                    merchantId,
                    storeId,
                    reason,
                }
            );
            return response.data.body;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
